import * as React from 'react'
import { Alert } from '@mui/material'
import { useEffect, useState } from 'react'
import './AlertNotification.css'

interface IAlertNotification {
  text: string | JSX.Element
  time?: number
  icon?: any
}

const AlertNotification = ({ text, icon, time = 5000 }: IAlertNotification) => {
  const [showAlert, setShowAlert] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAlert(false)
    }, time)

    return () => { clearTimeout(timer) }
  }, [])

  return <Alert
            className='alert_notification'
            data-animation={showAlert}
            role="alert"
            aria-live="polite"
            icon={icon}
            severity="success"
        >
            {text}
        </Alert>
}

export default AlertNotification
